/* eslint-disable no-console */
import { Input, Typography } from 'antd';
import { useEffect, useState } from 'react';

import { InvertFillButton } from '../InvertFillButton';
import '../DocumitraAdditionalDetail/style.scss';
import callApi from '../../Api/config';
import { DOCUMENT_USER_ADDITIONAL_DETAILS } from '../../constants/EntityName';
import { toastError, toastSuccess } from '../../service/Toast';

const { Text } = Typography;

const FinalEmailTrackingDetail = (props: any) => {
  // Always derive the persisted ("saved") snapshot from the latest prop so
  // updates made via the small "Final Email to be sent" required modal at
  // the top of the page are reflected here immediately.
  const saved = {
    trackingId: props?.finalEmailTrackingDetails?.trackingId || '',
    carrierName: props?.finalEmailTrackingDetails?.carrierName || '',
    trackingLink: props?.finalEmailTrackingDetails?.trackingLink || '',
  };
  const hasSaved = !!saved.trackingId || !!saved.carrierName || !!saved.trackingLink;

  const [trackingDetail, setTrackingDetail] = useState<any>(saved);
  const [isEditing, setIsEditing] = useState(!hasSaved);

  // Re-sync the editable inputs whenever the parent supplies new
  // finalEmailTrackingDetails (e.g. after the required modal saves).
  useEffect(() => {
    setTrackingDetail(saved);
    setIsEditing(!hasSaved);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props?.finalEmailTrackingDetails?.trackingId,
    props?.finalEmailTrackingDetails?.carrierName,
    props?.finalEmailTrackingDetails?.trackingLink,
  ]);

  const handleOnchange = (e: any) => {
    const { name, value } = e.target;
    setTrackingDetail((prevState: any) => ({ ...prevState, [name]: value }));
  };

  const submitTrackingDetail = async () => {
    const payload = {
      finalEmailTrackingDetails: trackingDetail,
    };
    try {
      const res = await callApi(
        `${DOCUMENT_USER_ADDITIONAL_DETAILS}/${props?.memberId}`,
        'PATCH',
        payload
      );
      if (res?.data?.statusCode === 200) {
        toastSuccess(`Final email tracking details updated successfully.`);
        props?.onUpdate?.(payload.finalEmailTrackingDetails);
        setIsEditing(false);
      }
    } catch (error) {
      console.error('Error:', error);
      toastError(`An error occurred while updating final email tracking details.`);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        borderRadius: '10px',
        border: '1px solid #e2e8f0',
        background: '#fff',
        padding: '18px 20px',
        marginBottom: '18px',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          fontSize: '16px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'black',
          marginBottom: '14px',
          paddingBottom: '10px',
          borderBottom: '1px solid #e2e8f0',
          lineHeight: 1.2,
        }}
      >
        <div>All Tracking Courier Details</div>
        <InvertFillButton
          variant="blue"
          fontSize="base"
          fontWeight="medium"
          onClick={isEditing ? submitTrackingDetail : () => setIsEditing(true)}
        >
          {isEditing ? 'Update' : 'Edit'}
        </InvertFillButton>
      </div>
      <div className="additional-container">
        <div className="additional-detail">
          <label className="additional-label">Tracking ID:</label>
          {isEditing ? (
            <Input
              type="text"
              name="trackingId"
              value={trackingDetail?.trackingId}
              onChange={handleOnchange}
            />
          ) : (
            <div className="additional-value">{saved.trackingId || '—'}</div>
          )}
        </div>
        <div className="additional-detail">
          <label className="additional-label">Carrier Name:</label>
          {isEditing ? (
            <Input
              type="text"
              name="carrierName"
              value={trackingDetail?.carrierName}
              onChange={handleOnchange}
            />
          ) : (
            <div className="additional-value">{saved.carrierName || '—'}</div>
          )}
        </div>
        <div className="additional-detail">
          <label className="additional-label">Tracking Link:</label>
          {isEditing ? (
            <Input
              type="text"
              name="trackingLink"
              value={trackingDetail?.trackingLink}
              onChange={handleOnchange}
            />
          ) : (
            <div className="additional-value">{saved.trackingLink || '—'}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinalEmailTrackingDetail;
